// extracted by mini-css-extract-plugin
export var cards = "Cards-module--cards--nKhMv";
export var layout = "Cards-module--layout--CK50L";
export var card = "Cards-module--card--O1oQr";
export var image = "Cards-module--image--Eqe3+";
export var heading = "Cards-module--heading--9OVEE";
export var link = "Cards-module--link--If0Sc";
export var text = "Cards-module--text--HBFVS";